import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import CashAdjustmentService from "../../services/cash/cashAdjustmentService";

import {

  setCashAdjustmentForm,
  updateCashAdjustmentField,
  clearCashAdjustmentForm,

  setLoading,

  openModal,
  closeModal

} from "../../store/slices/cash/cashAdjustmentSlice";

import useAlerts from "../useAlerts";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";

import { useCashSession } from "./useCashSession";
import { useCashMovements } from "./useCashMovements";
import { CashMovementType } from "../../types/cash/CashMovementType";

export const useCashAdjustment = () => {

  const dispatch: AppDispatch = useDispatch();

  const { form, loading, showModal } = useSelector(
    (state: RootState) => state.cashAdjustment
  );

  const { show: showAlert } = useAlerts();
  const { handle } = useApiErrorHandler();

  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const { getActiveSession } = useCashSession();
  const { getSessionMovements } = useCashMovements();

  const adjustment = async (data: any) => {

    try {

      showLoadingIndicator();
      dispatch(setLoading(true));

      const response = await CashAdjustmentService.adjustment(data);

      if (response?.statusCode === 200 || response?.statusCode === 201) {

        showAlert(
          response.type,
          response.title,
          response.message
        );

        dispatch(closeModal());
        dispatch(clearCashAdjustmentForm());

        await getActiveSession();

        await getSessionMovements(
          data.sessionId,
          [
            CashMovementType.ADJUSTMENT_IN,
            CashMovementType.ADJUSTMENT_OUT
          ]
        );

      }

    } catch (error) {

      handle(error);

    } finally {

      hideLoadingIndicator();
      dispatch(setLoading(false));

    }

  };

  const updateField = (field: string, value: any) => {

    dispatch(updateCashAdjustmentField({
      field,
      value
    }));

  };

  const setForm = (data: any) => {

    dispatch(setCashAdjustmentForm(data));

  };

  const clearForm = () => {

    dispatch(clearCashAdjustmentForm());

  };

  const open = () => dispatch(openModal());

  const close = () => dispatch(closeModal());

  const clear = () => {
    dispatch(clearCashAdjustmentForm());
    dispatch(closeModal());
  };

  return {

    form,
    loading,
    showModal,

    adjustment,

    updateField,
    setForm,
    clearForm,
    clear,

    open,
    close

  };

};